import { FC } from "react";
import { Stack } from "capitalrx-components-2.0/lib/layout";
import { Subheading } from "capitalrx-components-2.0/lib/typography";
import "./NoResultsSection.scss";

interface NoResultsSectionProps {
  readonly message: string;
}

export const NoResultsSection: FC<NoResultsSectionProps> = ({ message }) => {
  return (
    <Stack spacing="medium" alignment="center" className="no-results-section">
      <div className="no-results-illustration">
        <div className="no-results-background" />
        <div className="no-results-page">
          <div className="no-results-page-title" />
          <div className="no-results-page-line" />
          <div className="no-results-page-line" />
          <div className="no-results-page-line" />
          <div className="no-results-page-line" />
        </div>
        <div className="no-results-lens">
          <div className="no-results-lens-circle" />
          <div className="no-results-lens-handle" />
        </div>
      </div>
      <Subheading>{message}</Subheading>
    </Stack>
  );
};
